import AnimatedTiles from 'phaser-animated-tiles/dist/AnimatedTiles.js';
import { GameObjects, Tilemaps, Types } from 'phaser';
import { Player } from './player';
export class MyScene extends Phaser.Scene {
  moveKeys: any;
  player1: Player;
  sprite: GameObjects.Sprite;
  debugGraphics;
  walls: Tilemaps.StaticTilemapLayer;
  map: Tilemaps.Tilemap;
  goalsTileLayer: Tilemaps.StaticTilemapLayer;
  constructor() {
    super('myGame');
  }
  preload() {
    this.loadPrincess();
    this.loadBlob();
    this.load.image('bw1bit', ['1bit.png','normalmap.png']);
    this.load.tilemapTiledJSON('bw1bit', 'bw1bit.json');
    this.load.scenePlugin(
      'animatedTiles',
      AnimatedTiles,
      'animatedTiles',
      'animatedTiles'
    );
  }

  create() {
    this.createMap();
    this.createStartPoint();
    this.debugGraphics = this.add.graphics();
    this.cameras.main.setBounds(0, 0, this.map.widthInPixels, this.map.heightInPixels);
    this.cameras.main.startFollow(this.player1);
    this.lights.enable().setAmbientColor(0xcccccc);
  }

  update() {
    // this.drawDebug();
    if(this.isLevelComplete()) {
      console.log("hurray");
      const gameMenuEl = document.getElementById('game-menu');
      gameMenuEl.classList.remove("hidden");
    }
  }

  createMap = () => {
    this.map = this.make.tilemap({
      key: 'bw1bit',
      tileWidth: 16,
      tileHeight: 16,
      width: 512,
      height: 512,
    });
    const tileset = this.map.addTilesetImage('bw1bit');
    this.map.createStaticLayer('bg', tileset, 0, 0);
    this.walls = this.map.createStaticLayer('walls', tileset, 0, 0).setPipeline('Light2D');
    this.walls.setCollisionBetween(50, 343, true, true);
    this.goalsTileLayer = this.map.createStaticLayer('goals', tileset, 0, 0);
    const decor = this.map.createDynamicLayer('decor', tileset, 0, 0).setPipeline('Light2D');
    const decorTiles = decor.getTilesWithinWorldXY(0,0,512,512);
    const animatedTiles = (<any>this).sys.animatedTiles;
    animatedTiles.init(this.map);
    const lightIds = [209, 225, 241, 257];
    const lightTiles = decorTiles.filter(t => lightIds.includes(t.index));lightTiles.forEach(t => {
      // Need at least one light, max lights set in config
      this.lights.addLight(t.pixelX, t.pixelY, 70, 0xffffff, 2.0);
    })
  }
  
  loadPrincess = () => {
    const walkConfig = {
      frameWidth: 16,
      frameHeight: 16,
      startFrame: 0,
      endFrame: 3,
    };
    this.load.spritesheet('princess_walk_U', 'princess_walk_U.png', walkConfig);
    this.load.spritesheet('princess_walk_D', 'princess_walk_D.png', walkConfig);
    this.load.spritesheet('princess_walk_R', 'princess_walk_R.png', walkConfig);
  };

  loadBlob = () => {
    const walkConfig = {
      frameWidth: 16,
      frameHeight: 16,
      startFrame: 0,
      endFrame: 3,
    };
    this.load.spritesheet('nega_walk', 'nega_walk.png', walkConfig);
  };

  createPrincess = (startPoint, walls) => {
    this.player1 = new Player(this, startPoint, walls);
  };

  drawDebug = () => {
    this.debugGraphics.clear();
    this.walls.renderDebug(this.debugGraphics, {
      tileColor: null, // Non-colliding tiles
      collidingTileColor: new Phaser.Display.Color(243, 134, 48, 200), // Colliding tiles
      faceColor: new Phaser.Display.Color(40, 39, 37, 255), // Colliding face edges
    });
  };

  isLevelComplete = () => {
    const p1OnTiles = this.goalsTileLayer.getTilesWithinWorldXY(this.player1.x,this.player1.y,this.player1.width,this.player1.height);
    const p2OnTiles = this.goalsTileLayer.getTilesWithinWorldXY(this.player1.second1.x,this.player1.second1.y,this.player1.second1.width,this.player1.second1.height);
    const p3OnTiles = this.goalsTileLayer.getTilesWithinWorldXY(this.player1.second2.x,this.player1.second2.y,this.player1.second2.width,this.player1.second2.height);
    const p1GoalReached = !p1OnTiles.find(t => t.index === -1);
    const p2GoalReached = !p2OnTiles.find(t => t.index === -1);
    const p3GoalReached = !p3OnTiles.find(t => t.index === -1);
    return p1GoalReached && p2GoalReached && p3GoalReached;
  }
  
  createStartPoint = () => {
    const gameObjects = this.map.objects[0];
    const startPoint = gameObjects.objects.find((go) => go.name === 'startPoint');
    this.createPrincess(
      startPoint,
      this.walls
    );
  }
}
